import React from 'react';
const ICON_BASEPATH = './images/brand-icons';

export function TwentyFourHourFitness({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/24HourFitness.svg`}
        alt=""
        style={{
            height: 96,
            marginTop: 6,
        }}
    />;
}

export function SeventySix({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/76.svg`}
        alt=""
        style={{
            height: 96,
            marginTop: 6,
        }}
    />;
}

export function Albertsons({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Albertsons.svg`}
        alt=""
        style={{
            height: 50,
        }}
    />;
}

export function AMC({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/AMC.svg`}
        alt=""
        style={{
            height: 28,
            marginBottom: 8,
        }}
    />;
}

export function Arco({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Arco.svg`}
        alt=""
        style={{
            height: 76,
            marginTop: 4,
        }}
    />;
}

export function BankOfAmerica({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/BankOfAmerica.svg`}
        alt=""
        style={{
            height: 80,
            marginTop: 10,
        }}
    />;
}

export function Chase({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Chase.svg`}
        alt=""
        style={{
            height: 15,
            marginBottom: 15,
        }}
    />;
}

export function Chevron({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Chevron.svg`}
        alt=""
        style={{
            height: 68,
            marginTop: 10,
        }}
    />;
}

export function Cinemark({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Cinemark.svg`}
        alt=""
        style={{
            height: 60,
        }}
    />;
}

export function CoffeeBean({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/CoffeeBean.svg`}
        alt=""
        style={{
            height: 74,
            marginTop: 4,
        }}
    />;
}

export function Costco({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Costco.svg`}
        alt=""
        style={{
            height: 24,
            marginBottom: 11,
        }}
    />;
}

export function CVS({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/CVS.svg`}
        alt=""
        style={{
            height: 26,
            marginBottom: 8,
        }}
    />;
}

export function DuaneReade({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/DuaneReade.svg`}
        alt=""
        style={{
            height: 68,
            marginTop: 14,
        }}
    />;
}

export function Dunkin({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Dunkin.svg`}
        alt=""
        style={{
            height: 68,
            marginTop: 6,
        }}
    />;
}

export function Exxon({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Exxon.svg`}
        alt=""
        style={{
            height: 84,
            marginTop: 8,
        }}
    />;
}

export function GoldsGym({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/GoldsGym.svg`}
        alt=""
        style={{
            height: 6,
            marginBottom: 19,
        }}
    />;
}

export function Kroger({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Kroger.svg`}
        alt=""
        style={{
            width: 98,
            marginTop: 6,
        }}
    />;
}

export function LAFitness({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/LAFitness.svg`}
        alt=""
        style={{
            width: 74,
            marginBottom: 10,
        }}
    />;
}

export function Mobil({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Mobil.svg`}
        alt=""
        style={{
            width: 70,
            marginBottom: 12,
        }}
    />;
}

export function Peets({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Peets.svg`}
        alt=""
        style={{
            width: 78,
            marginBottom: 13,
        }}
    />;
}

export function Ralphs({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Ralphs.svg`}
        alt=""
        style={{
            height: 74,
            marginTop: 6,
        }}
    />;
}

export function Regal({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Regal.svg`}
        alt=""
        style={{
            width: 80,
            marginBottom: 14,
        }}
    />;
}

export function Safeway({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Safeway.svg`}
        alt=""
        style={{
            width: 76,
            marginBottom: 14,
        }}
    />;
}

export function SavOn({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/SavOn.svg`}
        alt=""
        style={{
            height: 80,
            marginTop: 6,
        }}
    />;
}

export function Shell({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Shell.svg`}
        alt=""
        style={{
            height: 70,
            marginTop: 4,
        }}
    />;
}

export function Starbucks({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Starbucks.svg`}
        alt=""
        style={{
            height: 62,
            marginTop: 4,
        }}
    />;
}

export function Target({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Target.svg`}
        alt=""
        style={{
            height: 68,
            marginTop: 6,
        }}
    />;
}

export function Texaco({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Texaco.svg`}
        alt=""
        style={{
            height: 64,
            marginTop: 6,
        }}
    />;
}

export function Valero({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Valero.svg`}
        alt=""
        style={{
            height: 48,
            marginTop: 6,
        }}
    />;
}

export function Walgreens({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Walgreens.svg`}
        alt=""
        style={{
            width: 80,
            marginBottom: 12,
        }}
    />;
}

export function Walmart({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/Walmart.svg`}
        alt=""
        style={{
            width: 80,
            marginBottom: 12,
        }}
    />;
}

export function WellsFargo({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/WellsFargo.svg`}
        alt=""
        style={{
            height: 52,
            marginTop: 4,
        }}
    />;
}

export function WholeFoods({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/WholeFoods.svg`}
        alt=""
        style={{
            height: 68,
            marginTop: 6,
        }}
    />;
}

export function WinCo({ variant = 'dark' }) {
    return <img src={`${ICON_BASEPATH}/${variant}/WinCo.svg`}
        alt=""
        style={{
            width: 76,
            marginBottom: 6,
        }}
    />;
}
